import { z } from "zod";
import {
  SectionSpacingSchema,
  TextAlignSchema
} from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionInfoBlocksItemSchema = z.object({
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  image: z.union([
    z.object({
      src: z.string().optional().nullable(),
      alt: z.string().optional().nullable()
    }),
    z.string()
  ]).optional().nullable(),
  contentAlign: TextAlignSchema.optional().nullable(),
  link: z.string().optional().nullable()
});
const FeatureSectionInfoBlocksSchema = z.object({
  id: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  textAlign: TextAlignSchema.optional().nullable(),
  items: FeatureSectionInfoBlocksItemSchema.array().optional().nullable()
}).merge(SectionSpacingSchema);
export default FeatureSectionInfoBlocksSchema;
